module.exports = __webpack_public_path__ + "static/media/55_000087.55dd358d.jpg";